import script from "./form-gallery.vue?vue&type=script&setup=true&lang=ts"
export * from "./form-gallery.vue?vue&type=script&setup=true&lang=ts"

import "./form-gallery.vue?vue&type=style&index=0&id=40ddea45&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40ddea45"]])

export default __exports__